import { render, staticRenderFns } from "./barnchScroll.vue?vue&type=template&id=5d858c3a&scoped=true"
import script from "./barnchScroll.vue?vue&type=script&lang=js"
export * from "./barnchScroll.vue?vue&type=script&lang=js"
import style0 from "./barnchScroll.vue?vue&type=style&index=0&id=5d858c3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d858c3a",
  null
  
)

export default component.exports